// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__mAc7z","errors":"Errors_errors__AWGC4"};